import {usePlaneduHttpService} from "../service/planedu.http.service";
import {PaymentMethodEntity} from "../entity/payment-method.entity";

export function usePaymentMethodRepository() {
  const httpService = usePlaneduHttpService<PaymentMethodEntity>('payment-method');
  return {
    ...httpService,
  }
}